import React from 'react';
import PersonIcon from '@material-ui/icons/Person';
import CloudIcon from '@material-ui/icons/Cloud';
import CloudOffIcon from '@material-ui/icons/CloudOff';
import LocationOnIcon from '@material-ui/icons/LocationOn';
import AccessTimeIcon from '@material-ui/icons/AccessTime';
import DirectionsCarIcon from '@material-ui/icons/DirectionsCar';
import DoneAllIcon from '@material-ui/icons/DoneAll';
import RestoreIcon from '@material-ui/icons/Restore';
import EmojiTransportation from '@material-ui/icons/EmojiTransportation';
import CommuteIcon from '@material-ui/icons/Commute';

export const legendItemsCards = [
  [
    { title: 'Card Icons' },
    { title: 'Master Visit', iconComponent: <span className="icon-master-visit icon-svg asw-icon" /> },
    { title: 'Copy Visit', iconComponent: <span className="icon-copy-visit icon-svg asw-icon" /> },
    { title: 'Rest Time', iconComponent: <span className="icon-rest-time icon-svg asw-icon" /> },
  ],
  [
    { title: 'Treatment colours' },
    { title: 'Multiple Timeslots', iconComponent: <span className="icon-multiple-timeslots icon-svg asw-icon" /> },
    { title: 'One Timeslot', iconComponent: <span className="icon-one-timeslot icon-svg asw-icon" /> },
    { title: 'Specific Time', iconComponent: <span className="icon-specific-time icon-svg asw-icon" /> },
    { title: 'Non-patient Activity', iconComponent: <span className="icon-NPA icon-svg asw-icon" /> },
  ],
  [
    { title: 'Visit Status Colours' },
    { title: 'Late, not started', iconComponent: <span className="icon-late_not_started icon-svg asw-icon" /> },
    { title: 'Completed', iconComponent: <span className="icon-completed icon-svg asw-icon" /> },
    { title: 'Started', iconComponent: <span className="icon-started icon-svg asw-icon" /> },
  ],
  [
    { title: 'Treatment RAG Status' },
    { title: 'Visit’s RAG Status Green', iconComponent: <span className="icon-RAG-green icon-svg asw-icon" /> },
    { title: 'Visit’s RAG Status Yellow', iconComponent: <span className="icon-RAG-yellow icon-svg asw-icon" /> },
    { title: "Visit's RAG status Amber", iconComponent: <span className="icon-RAG-amber icon-svg asw-icon" /> },
    { title: "Visit's RAG status Red", iconComponent: <span className="icon-RAG-red icon-svg asw-icon" /> },
  ],
  [],
  // [
  //   { title: 'Complited', iconComponent: <span className="icon-complited icon-svg asw-icon" /> },
  //   { title: 'Retrospective Completed', iconComponent: <span className="icon-complited-retro icon-svg asw-icon" /> },
  //   { title: 'Copy', iconComponent: <span className="icon-copy-card icon-svg asw-icon" /> },
  // ],
];

export const legendItemsOthers = [
  [
    { title: 'Other Icons' },
    {
      title: 'Mileage Cap',
      iconComponent: <span className="icon-extend icon-radius icon-small p-x-4 milage-cap-icon" />,
    },
    { title: 'Review', iconComponent: <span className=" icon-reschedule-legend icon-svg asw-icon" /> },
    { title: 'Unassigned', iconComponent: <span className="icon-unassigned-legend icon-svg asw-icon" /> },
    { title: 'Completed Visit', iconComponent: <DoneAllIcon fontSize="small" /> },
    { title: 'Retrospective Visit', iconComponent: <RestoreIcon fontSize="small" /> },
    { title: 'Bundled Visit', iconComponent: <span className="icon-extend icon-bundle-visits icon-small" /> },
    { title: 'Unbundle Visit', iconComponent: <span className="icon-extend icon-unbundle-visits icon-medium" /> },
    { title: 'Assign Visit', iconComponent: <span className="icon-extend icon-assign-visits" /> },
    { title: 'Convert visit', iconComponent: <span className="icon-convert-visit-call icon-svg asw-icon" /> },
  ],
  [
    { title: 'text' },
    { title: 'Information', iconComponent: <span className="icon-extend icon-info-more icon-small" /> },
    { title: 'Treatment Duration', iconComponent: <AccessTimeIcon fontSize="small" /> },
    { title: 'Travel Duration', iconComponent: <DirectionsCarIcon fontSize="small" /> },
    { title: 'Planned Travel Mileage', iconComponent: <CommuteIcon /> },
    { title: 'Planned Travel Mileage To Base', iconComponent: <EmojiTransportation /> },
  ],
  [
    { title: 'text' },
    { title: 'Clinician On Time', iconComponent: <span className="clinician-on-time icon-svg asw-icon" /> },
    { title: 'Clinician Late', iconComponent: <span className="clinician-late icon-svg asw-icon" /> },
    {
      title: 'Visits Started in Different Order',
      iconComponent: <span className="different-order icon-svg asw-icon" />,
    },
  ],
  [
    { title: 'text' },
    { title: 'Required Clinicians', iconComponent: <span className="icon-extend icon-medic icon-medium" /> },
    { title: 'Remaining Clinicians', iconComponent: <PersonIcon fontSize="small" /> },
    { title: 'Multiple times', iconComponent: <span className="icon-multiple-times  icon-medium npa-icon" /> },
  ],
  [
    { title: 'text' },
    {
      title: 'Clinician availability status',
      iconComponent: <span className="clinician_availability icon-svg asw-icon" />,
    },
    { title: 'Location', iconComponent: <LocationOnIcon fontSize="small" /> },

    { title: 'Clinician Online', iconComponent: <CloudIcon fontSize="small" /> },
    { title: 'Clinician Offline', iconComponent: <CloudOffIcon fontSize="small" /> },
  ],
];
